import queryString from 'query-string'

export const getGoBackPath = ({ pathname, search } = global.location) =>
  `${pathname}${search || ''}`

export const createBillingLinkWithGoBack = (pathname, params = {}, location) => ({
  pathname,
  search: queryString.stringify(
    {
      ...params,
      goBack: getGoBackPath(location),
    },
    { arrayFormat: 'bracket' },
  ),
})

export const createBillingTopUpLink = (pathname, location) =>
  createBillingLinkWithGoBack(pathname, {}, location)
